const DISMISS_KEY = 'cdr-pwa-dismissed';
const DISMISS_DAYS = 7;
const DELAY_MS = 10000;

export default function initPwaInstall() {
   const popup = document.querySelector('.js-pwa-popup');
   if (!popup) return;

   if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register(popup.dataset.sw).catch(() => {});
   }

   const isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;
   if (isStandalone) return;

   const isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
   const onMenu = popup.dataset.onMenu === '1';
   const forced = onMenu && window.location.hash === '#instalar';

   let dismissed = false;
   try {
      dismissed = Date.now() - Number(localStorage.getItem(DISMISS_KEY) || 0) < DISMISS_DAYS * 864e5;
   } catch (e) { /* storage bloqueado: mostramos igual */ }
   if (dismissed && !forced) return;

   let deferredPrompt = null;
   let delayDone = false;

   const open = () => {
      if (!delayDone || popup.classList.contains('active')) return;
      if (!deferredPrompt && !isIOS) return; // navegador sin soporte de instalación
      popup.classList.toggle('is-ios', isIOS && !deferredPrompt);
      popup.classList.toggle('is-ios-menu', isIOS && !deferredPrompt && onMenu);
      popup.hidden = false;
      requestAnimationFrame(() => popup.classList.add('active'));
   };

   const close = (remember) => {
      popup.classList.remove('active');
      setTimeout(() => { popup.hidden = true; }, 400);
      if (remember) {
         try { localStorage.setItem(DISMISS_KEY, String(Date.now())); } catch (e) {}
      }
   };

   window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();
      deferredPrompt = e;
      open();
   });

   window.addEventListener('appinstalled', () => close(true));

   setTimeout(() => { delayDone = true; open(); }, forced ? 0 : DELAY_MS);

   popup.querySelector('.js-pwa-install').addEventListener('click', async () => {
      if (!deferredPrompt) return;
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      deferredPrompt = null;
      close(outcome !== 'accepted');
   });

   popup.querySelectorAll('.js-pwa-dismiss').forEach(btn => btn.addEventListener('click', () => close(true)));
   popup.addEventListener('click', (e) => { if (e.target === popup) close(true); });
   document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && popup.classList.contains('active')) close(true);
   });
}
